import { ApplicationForm } from "@/blocks/ApplicationForm";
import { ScreenLayout } from "@/blocks/ScreenLayout";

export const ApplicationStartScreen = () => {
  return (
    <ScreenLayout className="py-6">
      <ApplicationForm formType="applicationStart" />
    </ScreenLayout>
  );
};
